/*
 * The layout of a door's window (D37) as the theme reads it: the shapes the API sends in
 * `FieldDetailView.door_layout`, the built-in defaults, and the decisions of the window that can
 * go wrong without the markup looking wrong (which slide a button leads to, which format a
 * presentation offers). `DoorWindow.tsx` renders them.
 *
 * The API sends the layout that applies to the door, already merged whole or nothing and fitted
 * to the presentation (`queries.door_layout`). The defaults here only fill a key the API left
 * out, so a layout from before a key existed still renders.
 */
import { isHttpsUrl } from './RichText.js';
export const DEFAULT_STEP_LAYOUT = {
    order: ['image', 'title', 'text'],
    image_side: 'full',
    ratio: '16:9',
};
export const DEFAULT_DOOR_LABELS = {
    to_quiz: 'Zum Quiz',
    submit: 'Antwort abschicken',
    retry: 'Nochmal versuchen',
};
export const DEFAULT_DOOR_LAYOUT = {
    slide: DEFAULT_STEP_LAYOUT,
    quiz: DEFAULT_STEP_LAYOUT,
    prize: DEFAULT_STEP_LAYOUT,
    labels: DEFAULT_DOOR_LABELS,
    retry_slide: 1,
};
/**
 * The formats each presentation offers, the first one the fallback (backend `ALLOWED_RATIOS`).
 * A dialog offers the wide ones only: a taller picture pushes its button out of the window.
 */
export const DOOR_RATIOS = {
    page: ['16:9', '4:3', '1:1', 'auto'],
    dialog: ['16:9', '4:3'],
};
/** The layout of one step; the result stands where the quiz stood and takes its layout. */
export function stepLayout(layout, step) {
    const key = step === 'result' ? 'quiz' : step;
    return layout[key] ?? DEFAULT_STEP_LAYOUT;
}
export function doorLabels(layout) {
    return layout.labels ?? DEFAULT_DOOR_LABELS;
}
/** The id of a slide, counted from 1 as the window shows them: `folie-1`. */
export function slideId(index) {
    return `folie-${index + 1}`;
}
/**
 * The buttons of each slide. One slide is visible at a time, so every slide but the last one
 * leads on, also beside a link out: in the window a slide without it would be a dead end. The
 * slide's own `button` gives "Weiter" its text, its `link` stands above (both at once since
 * 24.10.2026; a link in `button` is read as the link). The last slide leads to the quiz under
 * the layout's label, or to nothing in a door without one.
 */
export function slideButtons(slides, following) {
    return slides.map((slide, index) => {
        const own = slide.button?.action === 'link' ? null : slide.button;
        const out = slide.link ?? (slide.button?.action === 'link' ? slide.button : null);
        const link = out !== null && isHttpsUrl(out.url) ? { label: out.label, href: out.url, external: true } : null;
        if (index + 1 < slides.length) {
            const label = own !== null && own.action === 'next' && own.label !== '' ? own.label : 'Weiter';
            return { primary: { label, href: `#${slideId(index + 1)}` }, link };
        }
        return {
            primary: following.quizHref === null
                ? null
                : { label: following.toQuizLabel, href: following.quizHref },
            link,
        };
    });
}
//# sourceMappingURL=door-window.js.map